import { StrapiComponent } from "~/types/strapi";
import { StrapiFieldOption } from "~/types/strapi/components/shared/StrapiFieldOption";

export enum StrapiFieldType {
  input = "input",
  select = "select",
  file = "file",
  checkboxGroup = "checkbox-group",
}

export interface StrapiField extends StrapiComponent {
  title: string;
  type: StrapiFieldType;
  placeholder?: string;
  hint?: string;
  description?: string;
  required?: boolean;
  uid?: string;
  options?: StrapiFieldOption[];
  additional?: any;
}
